module.exports = __webpack_public_path__ + "static/media/blueVert.e8d05913.png";